<template>
  <!-- 选择商品弹窗 -->
  <div class="bigbox">
    <el-dialog
      title="选择标签"
      :visible.sync="dialogVisible"
      width="700px"
      :before-close="handleClose"
      class="labelDialog"
    >
      <div>
        <div class="checked_all">
          <el-checkbox
            v-model="checkedAll"
            @change="toCheckAll"
            :indeterminate="isSelect"
            >全选</el-checkbox
          >
        </div>
        <div >
          <!-- <span v-for="(item,index) in labelListData">{{item.labelName}}</span> -->
          <div
            class="left-small-item"
            v-for="(item, index) in labelListData"
            :key="index"
            @click="oneTabBtn(item, index, labelListData)"
            :style="{
              'border-color': item.state ? changeColor : '',
              color: item.state ? changeColor : '',
            }"
          >
            <p class="widthP">{{ item.labelName }}</p>
            <img
              v-if="item.state"
              class="right-gou"
              src="../assets/images/right.png"
              alt
            />
          </div>
          <!-- <div
          div
          class="create_btn"
          style="cursor: pointer; width: 98px;margin-bottom:10px"
          @click="toCreateLabel"
        >
          <i class="el-icon-circle-plus label-add" style="padding-left:8px"></i>
          创建标签
        </div> -->
        
        </div>

        
        <!-- 已有标签 -->
         <!-- <div style="margin-top:20px">
        <div class="checked_all">
          已有标签
        </div> -->
        <!-- <div > -->
          <!-- <span v-for="(item,index) in labelListData">{{item.labelName}}</span> -->
          <!-- <div
            class="left-small-item"
            v-for="(item, index) in labelListData"
            :key="index"
            @click="oneTabBtn(item, index, labelListData)"
            
          >
            <p class="widthP">{{ item.labelName }}</p>
            <img
              class="right-gou1"
              src="../assets/images/delete.png"
              alt
            />
          </div> -->
        <!-- </div> -->
        
        <!-- </div> -->

        <!-- <router-link v-if="jumpPage == false" :to="{name: 'page-member-manage', query:{to: '/memberManage/labelManage/labelManage'}}" @click.native="refresh" style="text-decoration:none;">
              <div :style="{'color': changeColor}" class="create_btn" style="cursor: pointer;width: 70px;">
                  +创建标签
              </div>
            </router-link> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <div
          div
          :style="{ color: changeColor }"
          class="create_btn"
          style="cursor: pointer; width: 98px"
          @click="toCreateLabel"
        >
          <i class="el-icon-circle-plus label-add"></i>
          创建标签
        </div>
        <div>
          <el-button class="cancel_Btn" @click="cancelBtn" style="margin-left:240px">取消</el-button>
          <el-button class="sure_Btn" type="primary" @click="sureBtn"
            >确定</el-button
          >
        </div>
      </span>
    </el-dialog>
    <!-- 需要软件升级弹窗 -->
    <upgrade-software
      v-if="upSoftwareDialog"
      :value="upSoftwareDialog"
      @transferName5="transferName5"
    ></upgrade-software>
  </div>
</template>

<script>
import upgradeSoftware from "./upgrade-software.vue";
import {
  getBrandList,
  getTaobaocats,
  getSellercats,
  getTaobaoItemList,
} from "@/api/public";
import Pagination from "./pagination";
import { mapState, mapMutations, mapActions } from "vuex";
// import { getBuyerLabelByLabelName} from "../api/buyerLabelController";

import { getBuyerLabel } from "@/api/buyerLabel.js";
export default {
  name: "select-goods",
  components: { Pagination, upgradeSoftware },
  props: {
    labelState: {
      type: Boolean,
      default: false,
    },
    selectIdsArr: {
      type: Array,
      default: [],
    },
    // 是否是当前页跳转
    jumpPage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: false,
      checkedAll: false,
      labelListData: [],
      isSelect: false, // 全选，选择部分状态
      powerType321: true, // 打标签/标签查询的置灰权限
      upSoftwareDialog: false, // 需要软件升级的提示框
    };
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
  },
  watch: {
    labelState(newVal) {
      this.dialogVisible = newVal;
      if (newVal) {
        // console.log(this.selectIdsArr);
        // 勾选之前已选的标签
        if (this.selectIdsArr && this.selectIdsArr.length > 0) {
          this.labelListData.forEach((item) => {
            const state = this.selectIdsArr.includes(item.id);
            // console.log(this.selectIdsArr,item.id);
            if (state) {
              item.state = true;
            } else {
              item.state = false;
            }
          });
          // console.log( this.labelListData);
         
        }else {
          this.labelListData.forEach(item => {
            item.state = false;
          });
        }
      }
    },
  },
  created() {},
  mounted() {
    this.dialogVisible = this.labelState;
    this.getData();
    // 查标签权限
    // this.$checkSellerOwnRorNot({ids: this.$store.state.newIds}).then((res) => {
    //   this.$store.state.otherRight=res.data;
    //   // 其它（打标签/标签查询321）
    //   if(res.data.indexOf("321")!==-1){
    //     this.powerType321 = true;
    //   }
    // })
  },
  methods: {
    refresh() {
      this.$router.go(0);
    },
    // 软件升级弹窗返回
    transferName5() {
      this.upSoftwareDialog = false;
    },
    // 跳转到创建标签
    toCreateLabel() {
      // this.$router.push({ path: "/memberManage", query: { to:'/memberManage/labelManage/labelManage'} });
      let routeUrl = this.$router.resolve({
        path: "/manage/labelManage/labelManage",
        query: {},
      });
      window.open(routeUrl.href, "_blank");
    },
    // 勾选全选
    toCheckAll(val) {
      let that = this;
      // console.log("val",val)
      if (val == true) {
        this.labelListData.forEach((item, index) => {
          item.state = val;
          this.$myVue.set(that.labelListData, index, item);
          this.isSelect = false;
        });
      } else if (val == false) {
        this.labelListData.forEach((item, index) => {
          item.state = val;
          this.$myVue.set(that.labelListData, index, item);
        });
      }
    },

    cancelBtn() {
      let idArr = [];
      this.labelListData.forEach((item) => {
        if (item.state == true) {
          idArr.push(item.id);
        }
      });
      this.dialogVisible = false;
      this.$emit("transferName4", {
        dialogVisible: this.dialogVisible,
        idArr: idArr,
        cancel: true,
      });
    },
    handleClose(done) {
      this.cancelBtn();
    },
    sureBtn() {
      if (this.powerType321 == false) {
        this.upSoftwareDialog = true;
        return;
      }
      let idArr = [];
      let newArr = [];
      this.labelListData.forEach((item) => {
        if (item.state == true) {
          idArr.push(item.id);
          newArr.push(item);
        }
      });
      this.dialogVisible = false;
      this.$emit("transferName4", {
        dialogVisible: this.dialogVisible,
        idArr: idArr,
        selectArr: newArr,
      });
    },
    // 查询所有标签
    getData() {
      let that = this;
      // that.tableLoading = true;
      getBuyerLabel()
        .then((res) => {
          console.log(res);
          // that.tableLoading = false;
          if (res.code == "1") {
            that.labelListData = res.data;
            that.labelListData.forEach((item) => {
              item.state = false;
              // // 勾选之前已选的标签
              if (that.selectIdsArr.length > 0) {
                that.selectIdsArr.forEach((item2) => {
                  if (item.id == item2.id) {
                    item.state = true;
                  }
                });
              }
              // 一开始判断全选按钮是否选中
              let selectCount = 0;
              this.labelListData.forEach((item) => {
                if (item.state === true) {
                  selectCount = selectCount + 1;
                }
              });
              if (selectCount > 0 && selectCount < this.labelListData.length) {
                this.checkedAll = false;
                this.isSelect = true;
              } else if (selectCount == this.labelListData.length) {
                this.checkedAll = true;
                this.isSelect = false;
              } else {
                this.checkedAll = false;
                this.isSelect = false;
              }
            });

            // that.totalList = res.data.pageInfo.total
          }
          // this.getHintBuyerLabel(); // 标签管理提示
        })
        .catch((err) => {
          // that.tableLoading = false;
        });
    },
    //
    oneTabBtn(val, index, arr) {
      let that = this;
      let newObj = this.labelListData[index];
      newObj.state = !newObj.state;
      this.$myVue.set(this.labelListData, index, newObj);

      let selectCount = 0;
      this.labelListData.forEach((item) => {
        if (item.state === true) {
          selectCount = selectCount + 1;
        }
      });
      if (selectCount > 0 && selectCount < this.labelListData.length) {
        this.checkedAll = false;
        this.isSelect = true;
      } else if (selectCount == this.labelListData.length) {
        this.checkedAll = true;
        this.isSelect = false;
      } else {
        this.checkedAll = false;
        this.isSelect = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.left-small-item {
  z-index: 100;
  display: inline-block;
  // width: 110px;
  height: 28px;
  // border: 1px solid rgba(239, 239, 239, 1);
  border: 1px solid #dcdcdc;
  opacity: 1;
  border-radius: 2px;
  margin-right: 2px;
  margin-bottom: 16px;
  text-align: center;
  line-height: 28px;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  padding: 0px 10px;
  margin-right: 16px;
  border-radius: 2px;
  p {
    margin: 0;
    padding: 0;
  }
  .right-gou {
    position: absolute;
    bottom: 0px;
    right: -1px;
  }
    .right-gou1 {
    position: absolute;
    width: 14px;
    height: 14px;
    bottom: 13px;
    right: -1px;
  }
}
</style>
<style lang="scss">
.bigbox {
  z-index: 2000;
  .labelDialog .el-dialog {
    // height: 450px;
    .el-dialog__body {
      height: 210px;
      overflow: auto;
      background: #fff;
    }
    .el-dialog__footer {
      text-align: center;
      .cancel_Btn {
        width: 96px;
        height: 36px;
       color: #666666;
border-radius: 3px;
      border: 1px solid #dddddd;
      background-color: #fff;
    &:hover{
      color:#fe4d45 ;
      border: 1px solid #fe4d45;
      background-color: #FFF4F4;
    }
  &:active {
      color:#fe4d45 ;
      border: 1px solid #fe4d45;
      background-color: #FFF4F4;
  }
      }
      .sure_Btn {
        width: 96px;
        height: 36px;
        color: #ffffff;
border-radius: 3px;
      background-color: #fe4d45;
    &:hover{
      color: #fff ;
      opacity: 0.9;
      background-color: #fe4d45;
    }
  &:active {
      color:#fe4d45 ;
      border: 1px solid #fe4d45;
      background-color: #FFF4F4;
  }
      }
    }
  }
  .checked_all {
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 20px;
    margin-bottom: 16px;
  }
  .create_btn {
    height: 32px;
    line-height: 30px;
    font-size: 14px;
     color: #FE4D45;
border: 1px solid #fe4d45;
border-radius: 3px;
      background-color:#FFF4F4;
    &:hover{
      color: #FE4D45;
      background-color:#FFE5E5;
}
  &:active {
      color:#fe4d45 ;
      border: 1px solid #fe4d45;
      background-color: #FFF4F4;
  }
  }
  .dialog-footer1 {
    // display: flex;
    // background-color: #fff;
    // align-items: center;
    // justify-content: space-between;
  }
  .dialog-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
